<template>
  <component :is="el" :label="label" :prop="prop" :required="required">
    <div v-if="disabled" class="html-remarks">
      <p v-if="formData" :style="'height: ' + height / 2 + 'px;'"  v-safe-html="formData"></p>
    </div>
    <div v-else>
      <quill-editor v-model="formData" :options="editorOptions" :style="'height: ' + height + 'px; width: ' + width + '; overflow: auto;'"  @change="updated" />
    </div>
  </component>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

import { quillEditor } from 'vue-quill-editor'

export default {
  name: 'html-input',

  components: {
    quillEditor
  },



  props: {

    label: {
      type: String,
      default: null
    },

    value: {
      required: true
    },

    height: {
      type: [Number, String],
      default: 222
    },

    width: {
      type: [Number, String],
      default: 'auto'
    },

    disabled: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    showImage: {
      type: Boolean,
      default: true
    },

    showEmptyMessage: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: null
    },

    helpText: {
      type: String,
      default: null
    },

    prop: {
      type: String,
      default: null
    },

    noForm: {
      type: Boolean,
      default: false
    }

  },



  methods: {

    updated (value) {
/*
      if (value) {
        // Remove any residual html codes, after deleting the text in the editor
        var regexp = /<\/?\w+((\s+\w+(\s*=\s*(?:".*?"|'.*?'|[^'">\s]+))?)+\s*|\s*)\/?>/gi
        var text = value.replace(regexp, '').trim()

        if (!text) {
          value = null
        }
      }
*/
      this.$emit('input', value.html)
      this.$emit('change', value.html)
    }
  },

  watch: {
    value: function (val) {
      this.formData = val
    }
  },


  data () {
    return {
      formData: this.value,
      el: this.noForm ? 'div' : 'el-form-item',

      editorOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['blockquote', 'code-block'],

            [{'header': 1}, {'header': 2}],               // custom button values
            [{'list': 'ordered'}, {'list': 'bullet'}],
            [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
            [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
            [{'direction': 'rtl'}],                         // text direction

            [{'size': false}],  // custom dropdown
            [{'header': [1, 2, 3, 4, 5, 6, false]}],

            [{'color': []}, {'background': []}],          // dropdown with defaults from theme
            [{'font': []}],
            [{'align': []}],

            [{'image': this.showImage}, {'clean': true}]
          ]
        }
      }
    }
  }

}
</script>
